export default {
  AddComment: 1,
  AddLike: 2,
  FormData: 3
}



// WEBPACK FOOTER //
// ./src/modules/uaq/uaqActionType.js